export const LoginUserApi = 'api/Auth/User/Login';
export const RefreshTokenUserApi = 'api/Auth/User/RenewAccessToken';
export const LogoutApi = 'api/Auth/User/Logout';
export const LoginAzureApi = 'AuthService/api/auth/azure-login';
